export default "__VITE_ASSET__JwcZwLCz__"